// Marketing bundle — loaded only by `app/views/layouts/marketing.html.erb`.
// Marketing pages stay Rails-rendered ERB for SEO + SSR; this file ships
// only the JS those pages actually use, instead of the full `application.js`
// (which still feeds Devise/admin/paywall layouts during the migration).
//
// Controllers shipped here, in order of how often they're hit:
//   - menu             — mobile nav drawer in `shared/_marketing_header`
//   - modal            — guarantee terms dialog in `shared/_guarantee`
//   - calendly-modal   — the same controller under its own name, for the
//                        Calendly booking dialog in `shared/_pricing` (so its
//                        actions can't resolve to the guarantee/call modals)
//   - cookie-consent   — bottom-right banner; calls `initPostHog()` on accept
//   - load-more        — blog infinite scroll (uses Turbo Streams)
//   - syntax-highlight — code blocks in `docs/`
//   - code-tabs        — multi-language tab switcher in `docs/`
//   - blog-cost-calculator — free tool at `instrumente/calculator-cost-blog`
//   - pricing-offer    — Singur/Împreună/Noi switch in `shared/_pricing`
//   - meta-pixel       — fires Meta Pixel custom events on CTA clicks
//
// Turbo is kept because `blog_posts#index` responds with `format.turbo_stream`
// for the load-more pagination. PostHog is pulled in transitively by
// cookie_consent_controller's import.

import "@hotwired/turbo-rails"

import { Application } from "@hotwired/stimulus"

import MenuController from "./controllers/menu_controller"
import ModalController from "./controllers/modal_controller"
import CookieConsentController from "./controllers/cookie_consent_controller"
import LoadMoreController from "./controllers/load_more_controller"
import SyntaxHighlightController from "./controllers/syntax_highlight_controller"
import CodeTabsController from "./controllers/code_tabs_controller"
import BlogCostCalculatorController from "./controllers/blog_cost_calculator_controller"
import WordCycleController from "./controllers/word_cycle_controller"
import PricingOfferController from "./controllers/pricing_offer_controller"
import MetaPixelController from "./controllers/meta_pixel_controller"

const application = Application.start()
application.register("menu", MenuController)
application.register("modal", ModalController)
application.register("calendly-modal", ModalController)
application.register("cookie-consent", CookieConsentController)
application.register("load-more", LoadMoreController)
application.register("syntax-highlight", SyntaxHighlightController)
application.register("code-tabs", CodeTabsController)
application.register("blog-cost-calculator", BlogCostCalculatorController)
application.register("word-cycle", WordCycleController)
application.register("pricing-offer", PricingOfferController)
application.register("meta-pixel", MetaPixelController)
